var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: { name: _vm.modalName, width: "590", clickToClose: false },
      on: { opened: _vm.handleModalOpened },
    },
    [
      _c("div", { staticStyle: { position: "relative" } }, [
        _c(
          "button",
          {
            staticClass: "button-close",
            attrs: { role: "button" },
            on: { click: _vm.hideModal },
          },
          [_c("img", { attrs: { src: "/assets/app/class/icon-close.svg" } })]
        ),
        _vm._v(" "),
        _vm.type === "success"
          ? _c("canvas", { attrs: { id: "result-canvas" } })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "result-modal-header" },
          [_c("page-title", [_vm._v(_vm._s(_vm.modalTitle))])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "result-modal-content" }, [
          _c("p", { staticClass: "modal-description" }, [
            _vm._v(_vm._s(_vm.resultDescription)),
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "modal-icon",
            attrs: { src: _vm.modalIconPath },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "result-modal-footer" },
          [
            _c(
              "primary-button",
              { on: { click: _vm.handleClickFooterButton } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.buttonTitle) +
                    "\n                "
                ),
                _vm.type === "failed"
                  ? _c("a", {
                      staticClass: "email-link",
                      attrs: {
                        href: "mailto:support@readtheory.org?subject=Contact%20our%20support",
                      },
                    })
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }